<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'APPROVALS_EQUIPMENTS.FILTER.TITLE' | translate }}
  </span>
</mat-toolbar>

<form class="filter-content" [formGroup]="filtersForm" fusePerfectScrollbar>
  <input
    class="mt-4 input-legacy"
    formControlName="number"
    name="text"
    placeholder="{{ 'APPROVALS_EQUIPMENTS.FILTER.NUMBER' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <input
    class="mt-16 input-legacy"
    formControlName="name"
    name="text"
    placeholder="{{ 'APPROVALS_EQUIPMENTS.FILTER.NAME' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <equipment-type-legacy class="mt-16" formControlName="typeId"></equipment-type-legacy>

  <mat-divider class="mt-16"></mat-divider>

  <location-legacy class="mt-16" formControlName="locationId"></location-legacy>

  <mat-divider class="mt-16"></mat-divider>

  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-label for="companies">{{ 'APPROVALS_EQUIPMENTS.FILTER.COMPANY_PLACEHOLDER' | translate }}</mat-label>
    <mat-select formControlName="companies" multiple>
      <mat-select-trigger>
        {{
          filtersForm.get('companies').value && filtersForm.get('companies').value.length
            ? getPropertyValue(filtersForm.get('companies').value[0], companies, 'name')
            : ''
        }}
        <span *ngIf="filtersForm.get('companies').value?.length > 1">
          (+{{ filtersForm.get('companies').value.length - 1 }}
          {{
            filtersForm.get('companies').value.length === 2
              ? ('APPROVALS_EQUIPMENTS.FILTER.COMPANY' | translate)
              : ('APPROVALS_EQUIPMENTS.FILTER.COMPANIES' | translate)
          }})
        </span>
      </mat-select-trigger>
      <mat-option *ngFor="let company of companies; let $index = index" [value]="company.id">
        {{ company.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16">
    {{ 'APPROVALS_EQUIPMENTS.FILTER.STATUS' | translate }}
  </div>

  <div class="filter-checkbox mt-16">
    <mat-checkbox
      labelPosition="before"
      *ngFor="let situtation of status.controls; let $index = index"
      [formControl]="situtation"
      [ngClass]="STATUS[$index].name + '-fg'"
    >
      <i class="angularjs-fuse-icon {{ STATUS[$index].icon }} mr-32"></i>
      {{ STATUS[$index].name | statusApprovals }}
    </mat-checkbox>
  </div>

  <mat-divider class="mt-16"></mat-divider>
</form>
